import { hot } from "react-hot-loader/root";
import React, { Fragment } from "react";
import { Provider } from "react-intl-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import ReactDOM from "react-dom";
import configureStore from "./redux/store";
import moment from "moment-timezone";
import statsSagas from "./modules/stats/sagas/index";
import statsSummarySagas from "./modules/stats/sagas/summary";
import photothequeSagas from "./redux/sagas/photothequeSagas";
import visitSagas from "./redux/sagas/visitSagas";
import logSagas from "./redux/sagas/logsSagas";
import surveySagas from "./redux/sagas/surveySagas";
import userSagas from "./redux/sagas/userSagas";
import authSagas from "./redux/sagas/authSagas";
import planningSagas from "./redux/sagas/planningSagas";
import sectorsSagas from "./redux/sagas/sectorsSagas";
import pdcsSagas from "./redux/sagas/pdcsSagas";
import allSectorsSagas from "./redux/sagas/allSectorsSagas";
import referentielsSagas from "./redux/sagas/referentielsSagas";
import commercialSagas from "./redux/sagas/commercialSagas";

import modelsSagas from "./redux/sagas/modelsSagas";
import expenseReportsSagas from "./modules/presence/sagas/expenseReportsSagas";
import transfersSagas from "./modules/presence/sagas/transfersSagas";
import premiumSagas from "./redux/sagas/premiumSagas";
import presenceSagas from "./modules/presence/sagas/presenceSagas";
import absenceTypesSagas from "./modules/presence/sagas/absenceTypesSagas";
import vacationPresenceSagas from "./modules/presence/sagas/index";
import clientsSagas from "./redux/sagas/clientsSagas";

import { IntlProvider } from "react-intl-redux";
import "./styles/tailwind.generated.css";
// Components
import App from "./components/App.js";
import usersSectorsSagas from "./redux/sagas/usersSectorsSagas";

import "./../src/configs/pluralize";

// Set timezone
moment.tz.setDefault("Europe/Paris");
moment.locale("fr");
//import registerServiceWorker from "./registerServiceWorker"; Progressive Web App

const store = configureStore();
store.runSaga(statsSagas);
store.runSaga(statsSummarySagas);
store.runSaga(photothequeSagas);
store.runSaga(visitSagas);
store.runSaga(surveySagas);
store.runSaga(userSagas);
store.runSaga(authSagas);
store.runSaga(planningSagas);
store.runSaga(sectorsSagas);
store.runSaga(pdcsSagas);
store.runSaga(allSectorsSagas);
store.runSaga(referentielsSagas);
store.runSaga(commercialSagas);
store.runSaga(modelsSagas);
store.runSaga(logSagas);
store.runSaga(expenseReportsSagas);
store.runSaga(premiumSagas);
store.runSaga(usersSectorsSagas);
store.runSaga(transfersSagas);
store.runSaga(absenceTypesSagas);
store.runSaga(vacationPresenceSagas);
store.runSaga(presenceSagas);
store.runSaga(clientsSagas);

const Root = ({ store }) => {
  //let history = syncHistoryWithStore(Router, store);
  return (
    <Provider store={store}>
      <IntlProvider>
        <Router>
          <Fragment>
            <Route path="/" component={App} />
          </Fragment>
        </Router>
      </IntlProvider>
    </Provider>
  );
};

export default (process.env.NODE_ENV === "development" ? hot(Root) : Root);
//export default Root;

ReactDOM.render(<Root store={store} />, document.getElementById("root"));
//registerServiceWorker();



// WEBPACK FOOTER //
// src/index.js